import React from 'react'

import arrow from '../../../static/06-2020/Jurigo-11.svg'
import './buttonWithArrow.css'

const ButtonWithArrow = ({ onClick, children, fullWidth, disabled }) => (
    <div
        className={`button-with-arrow flex justify-center relative  ${
            !fullWidth ? 'md:justify-start' : ''
        }`}>
        <button
            className={`button-with-arrow btn-lg btn btn-secondary text-white rounded-full text-xl md:text-2xl p-5 flex-nowrap uppercase ${
                !fullWidth ? 'md:text-xs md:m-0 md:w-[92%]' : ''
            }`}
            type="submit"
            variant="contained"
            color="primary"
            onClick={onClick}
            disabled={disabled}>
            {children}
        </button>
        <img
            src={arrow}
            alt=""
            className={`absolute right-10 w-[30px] bottom-[82px] z-10 ${
                !fullWidth
                    ? 'mr-[-2rem] mb-[0rem] md:mr-[2.4rem] md:mb-[1rem]'
                    : ''
            }`}
        />
    </div>
)

export default ButtonWithArrow
